import { render } from "./ValidationForm.vue?vue&type=template&id=7f80ef62&scoped=true&ts=true"
import script from "./ValidationForm.vue?vue&type=script&lang=ts"
export * from "./ValidationForm.vue?vue&type=script&lang=ts"

import "./ValidationForm.vue?vue&type=style&index=0&id=7f80ef62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f80ef62"]])

export default __exports__